import React, { useEffect,useRef  } from "react";
import {useLockBodyScroll } from "../components/useLockBodyScroll"

const PopupModal = ({ isOpen, children, page }) => {
  const modalRef = useRef();
  useLockBodyScroll(isOpen);
  
  
  
  return (
    <div className="flex justify-center items-center ">
      {/* Trigger Button */}

      {/* Modal */}
      {isOpen && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center h-screen w-screen">
    <div
  className={`bg-white overflow-y-auto rounded-2xl modal-content-scrollable ${
    page === 'loginmodal'
      ? 'p-0 w-[90%] lg:w-[70%] 2xl:w-[50%]'
      : 'p-6 w-[90%] lg:w-[50%] xl:w-[35%]'
  }`}
>
  {children}
</div>


  </div>
)}

    </div>
  );
};

export default PopupModal;
